// extracted by mini-css-extract-plugin
export var accordion_container = "container-module--accordion_container--sCNjl";
export var faq_head = "container-module--faq_head---EfpH";
export var faq_sect = "container-module--faq_sect---jrxJ";
export var faq_text_width = "container-module--faq_text_width--DwWy+";
export var secondary_heading = "container-module--secondary_heading--7EQIE";